webpackJsonp([14],{

/***/ 1004:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__(113);
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__(3);
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__(7);

// EXTERNAL MODULE: ./src/components/inputs/index.js + 75 modules
var inputs = __webpack_require__(170);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LinkCreation.vue





/* harmony default export */ var LinkCreation = ({
  components: {
    TextInput: inputs["t" /* TextInput */]
  },
  data: function data() {
    return {
      title: '',
      url: ''
    };
  },

  computed: Object(vuex_esm["c" /* mapGetters */])({
    loading: 'skiliko/links/isLoading'
  }),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])({
    saveLink: 'skiliko/links/save'
  }), {
    save: function save() {
      var _this = this;

      this.loading = true;
      this.saveLink({ data: {
          title: this.title,
          url: this.url
        } }).then(function (link) {
        _this.$emit('saved', link);
        _this.loading = false;
      });
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-98664708","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LinkCreation.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.save()}}},[_c('text-input',{attrs:{"config":{ label: _vm.$t('linkcreation.title') }},model:{value:(_vm.title),callback:function ($$v) {_vm.title=$$v},expression:"title"}}),_vm._v(" "),_c('text-input',{attrs:{"config":{ type: 'url', label: _vm.$t('linkcreation.url'), required: true }},model:{value:(_vm.url),callback:function ($$v) {_vm.url=$$v},expression:"url"}}),_vm._v(" "),_c('v-btn',{attrs:{"primary":"","light":"","block":"","loading":_vm.loading,"type":"submit"}},[_vm._v(_vm._s(_vm.$t('linkcreation.save')))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_LinkCreation = (esExports);
// CONCATENATED MODULE: ./src/components/LinkCreation.vue
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  LinkCreation,
  components_LinkCreation,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_LinkCreation = (Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/toConsumableArray.js
var toConsumableArray = __webpack_require__(40);
var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/HeaderForm.vue




/* harmony default export */ var HeaderForm = ({
  components: {
    TextInput: inputs["t" /* TextInput */],
    FileInput: inputs["i" /* FileInput */]
  },
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      contentType: this.value.video ? 'video' : 'picture',
      header: extends_default()({
        video: '',
        picture: '',
        title: '',
        subtitle: '',
        actionTitle: '',
        actionHref: ''
      }, this.value)
    };
  },

  computed: {
    isValid: function isValid() {
      return (!!this.header.picture || !!this.header.video) && !!this.header.title && !!this.header.actionTitle && !!this.header.actionHref;
    },
    contents: function contents() {
      return [{ text: 'picture', value: 'picture', selected: this.contentType === 'picture' }, { text: 'video', value: 'video', selected: this.contentType === 'video' }];
    }
  },
  methods: {
    save: function save() {
      this.$emit('saved', this.contentType === 'video' ? extends_default()({}, this.header) : extends_default()({}, this.header, {
        video: ''
      }));
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4df0c415","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HeaderForm.vue
var HeaderForm_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticStyle:{"width":"480px"}},[_c('v-card-title',[_vm._v("\n    "+_vm._s(_vm.$t('headerform.title'))+"\n  ")]),_vm._v(" "),_c('v-card-text',[_c('v-btn-toggle',{attrs:{"options":_vm.contents},model:{value:(_vm.contentType),callback:function ($$v) {_vm.contentType=$$v},expression:"contentType"}}),_vm._v(" "),(_vm.contentType === 'picture')?_c('v-layout',{staticClass:"ma-2"},[_c('file-input',{attrs:{"config":{ label: _vm.$t('headerform.labels.picture'), required: true, path: 'headers' }},model:{value:(_vm.header.picture),callback:function ($$v) {_vm.$set(_vm.header, "picture", $$v)},expression:"header.picture"}})],1):_vm._e(),_vm._v(" "),(_vm.contentType === 'video')?_c('v-layout',{staticClass:"ma-2"},[_c('file-input',{attrs:{"config":{ label: _vm.$t('headerform.labels.video'), required: true, path: 'headers' }},model:{value:(_vm.header.video),callback:function ($$v) {_vm.$set(_vm.header, "video", $$v)},expression:"header.video"}}),_vm._v(" "),_c('file-input',{attrs:{"config":{ label: _vm.$t('headerform.labels.pictureForVideo'), path: 'headers' }},model:{value:(_vm.header.picture),callback:function ($$v) {_vm.$set(_vm.header, "picture", $$v)},expression:"header.picture"}})],1):_vm._e(),_vm._v(" "),_c('text-input',{attrs:{"config":{ label: _vm.$t('headerform.labels.title'), required: true }},model:{value:(_vm.header.title),callback:function ($$v) {_vm.$set(_vm.header, "title", $$v)},expression:"header.title"}}),_vm._v(" "),_c('text-input',{attrs:{"config":{ label: _vm.$t('headerform.labels.subtitle') }},model:{value:(_vm.header.subtitle),callback:function ($$v) {_vm.$set(_vm.header, "subtitle", $$v)},expression:"header.subtitle"}}),_vm._v(" "),_c('text-input',{attrs:{"config":{ label: _vm.$t('headerform.labels.actionTitle'), required: true }},model:{value:(_vm.header.actionTitle),callback:function ($$v) {_vm.$set(_vm.header, "actionTitle", $$v)},expression:"header.actionTitle"}}),_vm._v(" "),_c('text-input',{attrs:{"config":{ label: _vm.$t('headerform.labels.actionHref'), required: true }},model:{value:(_vm.header.actionHref),callback:function ($$v) {_vm.$set(_vm.header, "actionHref", $$v)},expression:"header.actionHref"}})],1),_vm._v(" "),_c('v-card-row',{attrs:{"actions":""}},[_c('v-btn',{attrs:{"block":"","light":"","primary":"","disabled":!_vm.isValid},nativeOn:{"click":function($event){$event.stopPropagation();return _vm.save()}}},[_vm._v("\n      "+_vm._s(_vm.$t('headerform.save'))+"\n    ")])],1)],1)}
var HeaderForm_staticRenderFns = []
var HeaderForm_esExports = { render: HeaderForm_render, staticRenderFns: HeaderForm_staticRenderFns }
/* harmony default export */ var components_HeaderForm = (HeaderForm_esExports);
// CONCATENATED MODULE: ./src/components/HeaderForm.vue
var HeaderForm_normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var HeaderForm___vue_template_functional__ = false
/* styles */
var HeaderForm___vue_styles__ = null
/* scopeId */
var HeaderForm___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var HeaderForm___vue_module_identifier__ = null
var HeaderForm_Component = HeaderForm_normalizeComponent(
  HeaderForm,
  components_HeaderForm,
  HeaderForm___vue_template_functional__,
  HeaderForm___vue_styles__,
  HeaderForm___vue_scopeId__,
  HeaderForm___vue_module_identifier__
)

/* harmony default export */ var src_components_HeaderForm = (HeaderForm_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/HeadersForm.vue




/* harmony default export */ var HeadersForm = ({
  components: {
    HeaderForm: src_components_HeaderForm
  },
  props: {
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      popup: false,
      headers: [].concat(toConsumableArray_default()(this.value)),
      active: 'header-0'
    };
  },

  computed: {
    videoPicture: function videoPicture() {
      return __webpack_require__(975);
    }
  },
  methods: {
    removeHeader: function removeHeader(i) {
      var newHeaders = [].concat(toConsumableArray_default()(this.headers));
      newHeaders.splice(i, 1);
      this.headers = newHeaders;
      this.active = 'header-' + (i === 0 ? 0 : i - 1);
      this.$emit('input', this.headers);
    },
    updateHeader: function updateHeader(header, i) {
      delete header.edit;
      var newHeaders = [].concat(toConsumableArray_default()(this.headers));
      newHeaders[i] = header;
      this.headers = newHeaders;
      this.$emit('input', this.headers);
    },
    addHeader: function addHeader(header) {
      this.popup = false;
      this.headers = [].concat(toConsumableArray_default()(this.headers), [header]);
      this.active = 'header-' + (this.headers.length - 1);
      this.$emit('input', this.headers);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c009249","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HeadersForm.vue
var HeadersForm_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h4',{staticClass:"subheading"},[_vm._v(_vm._s(_vm.$t('headersform.title')))]),_vm._v(" "),(_vm.headers.length)?_c('v-tabs',{staticClass:"elevation-1 mb-2",attrs:{"grow":"","scroll-bars":""},model:{value:(_vm.active),callback:function ($$v) {_vm.active=$$v},expression:"active"}},[_c('v-tabs-bar',{staticClass:"white",attrs:{"slot":"activators","light":""},slot:"activators"},[_vm._l((_vm.headers),function(header,i){return _c('v-tabs-item',{key:i,attrs:{"href":("#header-" + i),"ripple":""}},[_vm._v("\n        "+_vm._s(header.title)+"\n      ")])}),_vm._v(" "),_c('v-tabs-slider')],2),_vm._v(" "),_vm._l((_vm.headers),function(header,i){return _c('v-tabs-content',{key:i,attrs:{"id":("header-" + i)}},[_c('v-parallax',{class:{ 'parallax--video': !!header.video },attrs:{"src":header.picture || _vm.videoPicture,"height":300}},[_c('div',{staticClass:"slide-actions"},[_c('v-dialog',{model:{value:(header.edit),callback:function ($$v) {_vm.$set(header, "edit", $$v)},expression:"header.edit"}},[_c('v-btn',{attrs:{"slot":"activator","icon":"","light":"","primary":""},slot:"activator"},[_c('v-icon',[_vm._v("edit")])],1),_vm._v(" "),_c('header-form',{attrs:{"value":header},on:{"saved":function (x) { return _vm.updateHeader(x, i); }}})],1),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","light":"","error":""},nativeOn:{"click":function($event){$event.stopPropagation();return _vm.removeHeader(i)}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-container',[_c('v-layout',{attrs:{"column":"","justify-space-around":"","align-center":"","fill-height":""}},[_c('div',{staticClass:"text-xs-center"},[_c('h1',{staticClass:"mt-4 headline white--text"},[_vm._v(_vm._s(header.title))]),_vm._v(" "),_c('h2',{staticClass:"subheading white--text"},[_vm._v(_vm._s(header.subtitle))])]),_vm._v(" "),_c('v-btn',{staticClass:"mb-4 primary",attrs:{"large":"","light":"","to":{ path: header.actionHref }}},[_vm._v(_vm._s(header.actionTitle))])],1)],1)],1)],1)})],2):_vm._e(),_vm._v(" "),_c('v-dialog',{model:{value:(_vm.popup),callback:function ($$v) {_vm.popup=$$v},expression:"popup"}},[_c('v-btn',{attrs:{"slot":"activator","outline":"","primary":""},slot:"activator"},[_vm._v(_vm._s(_vm.$t('headersform.addHeader')))]),_vm._v(" "),_c('header-form',{attrs:{"value":{}},on:{"saved":function (x) { return _vm.addHeader(x); }}})],1)],1)}
var HeadersForm_staticRenderFns = []
var HeadersForm_esExports = { render: HeadersForm_render, staticRenderFns: HeadersForm_staticRenderFns }
/* harmony default export */ var components_HeadersForm = (HeadersForm_esExports);
// CONCATENATED MODULE: ./src/components/HeadersForm.vue
function injectStyle (ssrContext) {
  __webpack_require__(971)
  __webpack_require__(973)
}
var HeadersForm_normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var HeadersForm___vue_template_functional__ = false
/* styles */
var HeadersForm___vue_styles__ = injectStyle
/* scopeId */
var HeadersForm___vue_scopeId__ = "data-v-6c009249"
/* moduleIdentifier (server only) */
var HeadersForm___vue_module_identifier__ = null
var HeadersForm_Component = HeadersForm_normalizeComponent(
  HeadersForm,
  components_HeadersForm,
  HeadersForm___vue_template_functional__,
  HeadersForm___vue_styles__,
  HeadersForm___vue_scopeId__,
  HeadersForm___vue_module_identifier__
)

/* harmony default export */ var src_components_HeadersForm = (HeadersForm_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/Customization.vue








/* harmony default export */ var Customization = ({
  components: {
    TextInput: inputs["t" /* TextInput */],
    FileInput: inputs["i" /* FileInput */],
    LinkCreation: src_components_LinkCreation,
    HeadersForm: src_components_HeadersForm
  },
  data: function data() {
    var platform = this.$store.getters['skiliko/session/currentPlatform'];
    return {
      modal: false,
      colors: {
        primary: platform.settings.color.primary,
        secondary: platform.settings.color.secondary
      },
      headers: platform.settings.headers || [],
      feedbacks: platform.settings.feedbacks
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    platform: 'skiliko/session/currentPlatform',
    loading: 'skiliko/session/isLoading'
  }), {
    links: function links() {
      return this.platform.links;
    },
    settings: function settings() {
      return extends_default()({}, this.platform.settings, {
        feedbacks: this.feedbacks,
        headers: this.headers,
        color: {
          primary: this.colors.primary,
          secondary: this.colors.secondary
        }
      });
    }
  }),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])({
    savePlatform: 'skiliko/session/updateCurrentPlatform',
    deleteLink: 'skiliko/links/remove'
  }), {
    saveSettings: function saveSettings() {
      this.savePlatform({ data: {
          settings: stringify_default()(this.settings)
        } });
    },
    onLinkSaved: function onLinkSaved(link) {
      this.modal = false;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4445448b","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Customization.vue
var Customization_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',{staticClass:"mb-3"},[_c('v-card-title',[_vm._v(_vm._s(_vm.$t('pages.customization.style')))]),_vm._v(" "),_c('v-card-text',[(!_vm.platform.settings.disable_customization)?[_c('text-input',{attrs:{"config":{ type: 'color', label: _vm.$t('pages.customization.labels.color.primary') }},model:{value:(_vm.colors.primary),callback:function ($$v) {_vm.$set(_vm.colors, "primary", $$v)},expression:"colors.primary"}}),_vm._v(" "),_c('text-input',{attrs:{"config":{ type: 'color', label: _vm.$t('pages.customization.labels.color.secondary') }},model:{value:(_vm.colors.secondary),callback:function ($$v) {_vm.$set(_vm.colors, "secondary", $$v)},expression:"colors.secondary"}})]:_vm._e(),_vm._v(" "),(_vm.platform.multi_experts)?_c('headers-form',{attrs:{"value":_vm.headers},on:{"input":function (x) { return _vm.headers = x; }}}):_vm._e(),_vm._v(" "),_c('v-switch',{attrs:{"label":_vm.$t('pages.customization.labels.feedbacks'),"dark":""},model:{value:(_vm.feedbacks),callback:function ($$v) {_vm.feedbacks=$$v},expression:"feedbacks"}})],2),_vm._v(" "),_c('v-card-row',{attrs:{"actions":""}},[_c('v-btn',{attrs:{"loading":_vm.loading,"primary":"","light":"","block":""},nativeOn:{"click":function($event){$event.stopPropagation();return _vm.saveSettings()}}},[_vm._v("\n        "+_vm._s(_vm.$t('pages.customization.save'))+"\n      ")])],1)],1),_vm._v(" "),_c('v-card',[_c('v-card-title',[_vm._v(_vm._s(_vm.$t('pages.customization.links')))]),_vm._v(" "),_c('v-card-text',[_c('v-list',_vm._l((_vm.links),function(link,i){return _c('v-list-item',{key:i},[_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(link.title)+" - "+_vm._s(link.url))])],1),_vm._v(" "),_c('v-list-tile-action',[_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){$event.stopPropagation();return _vm.deleteLink({ id: link.id })}}},[_c('v-icon',[_vm._v("close")])],1)],1)],1)],1)}),1),_vm._v(" "),_c('v-dialog',{attrs:{"lazy":""},model:{value:(_vm.modal),callback:function ($$v) {_vm.modal=$$v},expression:"modal"}},[_c('v-btn',{attrs:{"slot":"activator","outline":"","primary":""},slot:"activator"},[_vm._v("\n          "+_vm._s(_vm.$t('pages.customization.addLink'))+"\n        ")]),_vm._v(" "),(_vm.modal)?_c('v-card',[_c('v-card-title',[_vm._v("\n            "+_vm._s(_vm.$t('pages.customization.addLink'))+"\n          ")]),_vm._v(" "),_c('v-card-text',[_c('link-creation',{on:{"saved":_vm.onLinkSaved}})],1)],1):_vm._e()],1)],1)],1)],1)}
var Customization_staticRenderFns = []
var Customization_esExports = { render: Customization_render, staticRenderFns: Customization_staticRenderFns }
/* harmony default export */ var pages_Customization = (Customization_esExports);
// CONCATENATED MODULE: ./src/pages/Customization.vue
var Customization_normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var Customization___vue_template_functional__ = false
/* styles */
var Customization___vue_styles__ = null
/* scopeId */
var Customization___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Customization___vue_module_identifier__ = null
var Customization_Component = Customization_normalizeComponent(
  Customization,
  pages_Customization,
  Customization___vue_template_functional__,
  Customization___vue_styles__,
  Customization___vue_scopeId__,
  Customization___vue_module_identifier__
)

/* harmony default export */ var src_pages_Customization = __webpack_exports__["default"] = (Customization_Component.exports);


/***/ }),

/***/ 971:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(972);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(747)("1fe70ca9", content, true);

/***/ }),

/***/ 972:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(746)(true);
// imports


// module
exports.push([module.i, ".slide-actions[data-v-6c009249]{position:absolute;top:.5em;right:.5em}", "", {"version":3,"sources":["/home/runner/work/manager/manager/src/components/HeadersForm.vue"],"names":[],"mappings":"AACA,gCACE,kBAAmB,AACnB,SAAU,AACV,UAAY,CACb","file":"HeadersForm.vue","sourcesContent":["\n.slide-actions[data-v-6c009249] {\n  position: absolute;\n  top: .5em;\n  right: .5em;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 973:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(974);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(747)("917a245e", content, true);

/***/ }),

/***/ 974:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(746)(true);
// imports


// module
exports.push([module.i, ".parallax.parallax--video img{height:100%;top:0;left:0;right:0;bottom:0;width:100%;-webkit-transform:none!important;transform:none!important;background-size:cover}", "", {"version":3,"sources":["/home/runner/work/manager/manager/src/components/HeadersForm.vue"],"names":[],"mappings":"AACA,8BACE,YAAa,AACb,MAAO,AACP,OAAQ,AACR,QAAS,AACT,SAAU,AACV,WAAY,AACZ,iCAAkC,AAC1B,yBAA0B,AAClC,qBAAuB,CACxB","file":"HeadersForm.vue","sourcesContent":["\n.parallax.parallax--video img {\n  height: 100%;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  width: 100%;\n  -webkit-transform: none!important;\n          transform: none!important;\n  background-size: cover;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 975:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/video.7cc9693.jpg";

/***/ })

});


// WEBPACK FOOTER //
// static/js/14.258cb36fb9384bfac2e0.js